var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExcerciseAttempted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 46.51 56.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:#8951b8;}.cls-5{fill:#e3ceef;}.cls-6{fill:url(#linear-gradient-4);}.cls-7{fill:url(#linear-gradient-5);}.cls-8{fill:url(#linear-gradient-6);}.cls-9{fill:url(#linear-gradient-7);}.cls-10{fill:url(#linear-gradient-8);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1572.02,
    y1: 17.72,
    x2: -1571.02,
    y2: 17.72,
    gradientTransform: "matrix(38.24, 0, 0, -51.77, 60107.74, 943.21)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9b62cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#985dcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#8f4ec7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#833ac1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -1564.26,
    y1: 8.61,
    x2: -1564.67,
    y2: 8.82,
    gradientTransform: "matrix(32.5, 0, 0, -32.5, 50851.48, 293.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#662d90",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#632d8c",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#5b2d81",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#4d2d6e",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#452d63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -1572.02,
    y1: 17.91,
    x2: -1571.02,
    y2: 17.91,
    gradientTransform: "matrix(38.24, 0, 0, -52.43, 60112.97, 969.86)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f6fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efdcfb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -1520.87,
    y1: 11.86,
    x2: -1521.73,
    y2: 12.26,
    gradientTransform: "matrix(17.49, 0, 0, -37.86, 26648.18, 490.66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efdcfb",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#baaad6",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679b2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -1314.54,
    y1: -92.9,
    x2: -1313.82,
    y2: -92.9,
    gradientTransform: "matrix(6.35, 0, 0, -6.36, 8671.72, -557.54)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdecf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#faa68e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -514.22,
    y1: -430.27,
    x2: -513.19,
    y2: -430.27,
    gradientTransform: "matrix(1.73, 0, 0, -1.73, 1214.67, -708.71)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8a7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e566e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -1514.57,
    y1: -8.74,
    x2: -1514.33,
    y2: -8.74,
    gradientTransform: "matrix(19.12, 0, 0, -19.12, 29276.73, -141.26)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ffcd3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#ffad2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -1502.51,
    y1: -14.31,
    x2: -1502.82,
    y2: -14.25,
    gradientTransform: "matrix(16.8, 0, 0, -17.94, 25537.97, -179.88)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#ed725d",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#fa704b",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7044"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "excercise_attempted",
    "data-name": "excercise attempted"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67458-2",
    "data-name": "Path 67458-2",
    className: "cls-1",
    d: "M38.24,3.27V48.5A3.27,3.27,0,0,1,35,51.77H3.27A3.27,3.27,0,0,1,0,48.5V13.12a4.26,4.26,0,0,1,1.24-3l9.5-9.5L10.8.58l0,0A2.22,2.22,0,0,1,12.29,0H35a3.27,3.27,0,0,1,3.27,3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67459",
    "data-name": "Path 67459",
    className: "cls-2",
    d: "M32.5,0H12.29a2.22,2.22,0,0,0-1.46.55l0,0-.06.05-9.5,9.5a4.26,4.26,0,0,0-1.24,3V32.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67460",
    "data-name": "Path 67460",
    className: "cls-3",
    d: "M40.19,57H8.5a3.26,3.26,0,0,1-3.27-3.27h0V7.84A3.26,3.26,0,0,1,8.5,4.57H40.19a3.26,3.26,0,0,1,3.27,3.27h0V53.72A3.26,3.26,0,0,1,40.19,57Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67461",
    "data-name": "Path 67461",
    className: "cls-4",
    d: "M12.91,5,5.69,12.25a1.85,1.85,0,0,1-1.91.44l-1.16-.4A2,2,0,0,0,.11,13.5a2,2,0,0,0-.11.64v-1a4.26,4.26,0,0,1,1.24-3l9.5-9.5L10.8.58l0,0a1.14,1.14,0,0,1,1.61.18,1.09,1.09,0,0,1,.19.33l.71,2.06A1.81,1.81,0,0,1,12.91,5Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_50726",
    "data-name": "Group 50726"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50724",
    "data-name": "Group 50724"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67462",
    "data-name": "Path 67462",
    className: "cls-5",
    d: "M38.19,15.55H10.5a1.07,1.07,0,0,1-1.06-1.07V12.89a1.07,1.07,0,0,1,1.06-1.07H38.19a1.07,1.07,0,0,1,1.06,1.07v1.59A1.07,1.07,0,0,1,38.19,15.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67463",
    "data-name": "Path 67463",
    className: "cls-5",
    d: "M31,24.07H10.5A1.07,1.07,0,0,1,9.44,23V21.41a1.07,1.07,0,0,1,1.06-1.07H31a1.07,1.07,0,0,1,1.07,1.07V23A1.07,1.07,0,0,1,31,24.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67464",
    "data-name": "Path 67464",
    className: "cls-5",
    d: "M38.19,32.59H10.5a1.07,1.07,0,0,1-1.06-1.07h0V29.93a1.07,1.07,0,0,1,1.06-1.07H38.19a1.07,1.07,0,0,1,1.06,1.07h0v1.59a1.07,1.07,0,0,1-1.06,1.07Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_50725",
    "data-name": "Group 50725"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67465",
    "data-name": "Path 67465",
    className: "cls-5",
    d: "M32.14,41.22H10.5a1.07,1.07,0,0,1-1.06-1.07h0V38.56a1.07,1.07,0,0,1,1.06-1.07H32.14a1.06,1.06,0,0,1,1.06,1.07h0v1.59a1.06,1.06,0,0,1-1.06,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67466",
    "data-name": "Path 67466",
    className: "cls-5",
    d: "M25.83,49.74H10.5a1.07,1.07,0,0,1-1.06-1.07h0V47.08A1.07,1.07,0,0,1,10.5,46H25.83a1.07,1.07,0,0,1,1.07,1.07h0v1.59a1.07,1.07,0,0,1-1.07,1.07Z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_67467",
    "data-name": "Path 67467",
    className: "cls-6",
    d: "M43.46,53.72V16.38c-.18.05-.13.36-.27.5L27.77,32.3l0,0a1.29,1.29,0,0,0-.33.55L26,36.71a.13.13,0,0,0,0,.13l17.4,17.4A3,3,0,0,0,43.46,53.72Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_50728",
    "data-name": "Group 50728"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50727",
    "data-name": "Group 50727"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67468",
    "data-name": "Path 67468",
    className: "cls-7",
    d: "M32.63,33.45,29.4,30.22l-1.88,1.89a1.29,1.29,0,0,0-.33.55l-.75,2.5-.16,1.42,1.42-.17,2.5-.74a1.4,1.4,0,0,0,.55-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67469",
    "data-name": "Path 67469",
    className: "cls-8",
    d: "M27.26,35.6a1.7,1.7,0,0,0-.81-.44L26,36.71a.14.14,0,0,0,.1.17h.08l1.55-.46A1.75,1.75,0,0,0,27.26,35.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67470",
    "data-name": "Path 67470",
    className: "cls-9",
    d: "M29.87,33.53v1.4a.54.54,0,0,0,.53.54.53.53,0,0,0,.38-.16L46.2,19.89a1.07,1.07,0,0,0,0-1.5h0l-1.73-1.73a1.06,1.06,0,0,0-1.5,0h0L27.55,32.08a.53.53,0,0,0,0,.75.55.55,0,0,0,.38.16h1.4a.54.54,0,0,1,.54.53Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_67471",
    "data-name": "Path 67471",
    className: "cls-10",
    d: "M46.2,18.39l-.87-.87L29.71,33.14a.57.57,0,0,1,.16.38v1.41a.53.53,0,0,0,.53.53.52.52,0,0,0,.38-.15L46.2,19.89a1.07,1.07,0,0,0,0-1.5Z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcerciseAttempted);
export default __webpack_public_path__ + "static/media/excercise-attempted.8cb4e05850f3eede795ac356be66e66f.svg";
export { ForwardRef as ReactComponent };